import { AssignCareDtoIn } from "../../../generated";
import { CareAssignment } from "../../../model/patient/CareAssignment";
import { fromDateToString } from "../../parseDate";

export const fromCareAssignmentToGenerated = (careAssignment: CareAssignment): AssignCareDtoIn => ({
  careTemplateId: careAssignment.careTemplate.id,
  date: fromDateToString(careAssignment.date),
});
